<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

interface Props extends /* @vue-ignore */ HTMLAttributes {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();
</script>

<template>
  <span :class="cn('shrink-0', props.class)" v-bind="$attrs">
    <slot />
  </span>
</template>
